import React from 'react';
import dayjs from 'dayjs';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

interface IProps {
  type: string;
  id: number;
  createdAt: number;
  ball: number;
}

const UserActivityCard = ({ type, id, createdAt, ball }: IProps) => {
  const t = useTranslations('profile.right_side');

  return (
    <Link href={`${globalConst.pageNames.RESULTS}/${id}`}>
      <div className="mb-4 rounded-xl bg-white p-4">
        <div className="flex items-center justify-between">
          <div className="rounded-sm border-none bg-green-50 px-2 text-green-500">{type}</div>
          <div className="text-gray-500">
            {dayjs(createdAt).format('DD.MM.YYYY HH:mm')}
            {/* {dayjs.unix(created_at).format("DD.MM.YYYY HH:mm")} */}
          </div>
        </div>
        <div className="my-4 flex items-center justify-between">
          <div className="text-gray-500">{t('test_varianti_raqami')}</div>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <div className="font-medium">№{id}</div>
        </div>
        <div className="flex items-center justify-between">
          <div className="text-gray-500">{t('toplangan_ball')}</div>
          <div className="font-medium text-green-500">
            {ball || 0} {t('ball')}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default UserActivityCard;
